"use client";

import Link from "next/link";
import { useApexPass } from "./ApexPassProvider";

/* Header entry point: "Sign in" for guests, the Pass (with a member mark) once signed in. */
export function PassButton({ className = "" }: { className?: string }) {
  const { me, openPanel } = useApexPass();
  if (!me?.signedIn) {
    return (
      <button type="button" onClick={() => openPanel("signin")} className={`rounded-lg px-3 py-2 hover:text-white ${className}`}>
        Apex Pass
      </button>
    );
  }
  return (
    <Link href="/apex-pass" className={`inline-flex items-center gap-1.5 rounded-lg px-3 py-2 hover:text-white ${className}`}>
      <span className={`h-2 w-2 rounded-full ${me.member ? "bg-amber-300 shadow-[0_0_8px_#fcd34d]" : "bg-amber-300"}`} />
      {me.member ? "Pass member" : "Your Pass"}
    </Link>
  );
}
